module.exports = __webpack_public_path__ + "static/media/PushtimargImage20.b326044e.jpg";